import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  faqData: [],
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const fetchFaqs = createAsyncThunk(
  "faqs/data",
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        "https://nutirents.developer-ourbase-camp.com/api/v1/faq"
      );
      return data.response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const faqsSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.faqData = action.payload;
        state.isSuccess = true;
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload;
        state.isSuccess = false;
      });
  },
});

export default faqsSlice.reducer;
